// Generated from build58 src/features/musicEdition/preferences.ts; do not edit.
import { limitEditionIntro } from './model';
// Treat device storage as untrusted; old/corrupt settings must not break the editor.
export function readEditionPreferences(raw) {
  try {
    if (!raw || raw.length > 4000) return null;
    const v = JSON.parse(raw);
    if (!v || typeof v !== 'object') return null;
    const p = v;
    if (
      p.version !== 1 ||
      !['all', 'year', 'month'].includes(String(p.period)) ||
      !['paper', 'night', 'orange', 'artwork'].includes(String(p.theme)) ||
      !['story', 'card'].includes(String(p.format)) ||
      !['editorial', 'poster', 'sleeve', 'ticket'].includes(String(p.template))
    )
      return null;
    const id = (v) => (typeof v === 'number' && Number.isSafeInteger(v) && v > 0 ? v : null);
    return {
      version: 1,
      period: p.period,
      theme: p.coverPalette === true ? 'artwork' : p.theme,
      format: p.format,
      // Retired frames migrate without discarding the member's other choices.
      template: p.template === 'poster' ? 'poster' : 'editorial',
      intro: typeof p.intro === 'string' ? limitEditionIntro(p.intro) : '',
      cardHeading: typeof p.cardHeading === 'string' ? limitEditionIntro(p.cardHeading) : undefined,
      selectedIds: Array.isArray(p.selectedIds)
        ? [...new Set(p.selectedIds.map(id).filter((n) => n !== null))].slice(0, 9)
        : null,
      quoteId: id(p.quoteId),
      artistIntroId: id(p.artistIntroId),
      quoteStart:
        typeof p.quoteStart === 'number' && Number.isFinite(p.quoteStart)
          ? Math.max(0, Math.min(100000, Math.floor(p.quoteStart)))
          : 0,
      quoteLength:
        p.quoteLength === 0
          ? 0
          : typeof p.quoteLength === 'number' && Number.isFinite(p.quoteLength)
            ? Math.max(1, Math.min(110, Math.floor(p.quoteLength)))
            : 0,
      showName: p.showName !== false,
      showStats: p.showStats !== false,
      showCovers: p.showCovers !== false,
      coverPalette: p.coverPalette === true,
      headliner: typeof p.headliner === 'string' && p.headliner.length <= 120 ? p.headliner : null,
      selectedWords: Array.isArray(p.selectedWords)
        ? [
            ...new Set(
              p.selectedWords.filter((v) => typeof v === 'string' && /^[가-힣a-z]{2,18}$/.test(v)),
            ),
          ].slice(0, 40)
        : undefined,
      friendInput:
        typeof p.friendInput === 'string' ? Array.from(p.friendInput).slice(0, 40).join('') : '',
      friendNickname:
        typeof p.friendNickname === 'string'
          ? Array.from(p.friendNickname.trim()).slice(0, 40).join('')
          : '',
    };
  } catch {
    return null;
  }
}
export function coverEditionPalette(hex) {
  if (!/^#[\da-f]{6}$/i.test(hex)) return undefined;
  const channels = [1, 3, 5]
    .map((i) => parseInt(hex.slice(i, i + 2), 16) / 255)
    .map((v) => (v <= 0.04045 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4));
  const luminance = channels[0] * 0.2126 + channels[1] * 0.7152 + channels[2] * 0.0722;
  const ink = luminance > 0.179 ? '#000000' : '#FFFFFF';
  // Black or white maximizes contrast (>=4.5:1); do not use low-contrast extracted accent text.
  return {
    background: hex,
    text: ink,
    muted: ink,
    accent: ink,
    tile: luminance > 0.179 ? '#DDDDDD' : '#333333',
  };
}
export function readEditionCheckpoints(raw) {
  try {
    const rows = JSON.parse(raw ?? '[]');
    if (!Array.isArray(rows)) return [];
    return rows
      .filter(
        (r) =>
          r &&
          typeof r.date === 'string' &&
          /^\d{4}-\d{2}-\d{2}T/.test(r.date) &&
          Number.isFinite(Date.parse(r.date)) &&
          ['count', 'reviews', 'perfect'].every(
            (key) => Number.isSafeInteger(r[key]) && r[key] >= 0,
          ) &&
          Number.isFinite(r.average) &&
          r.average >= 0 &&
          r.average <= 5,
      )
      .slice(0, 5);
  } catch {
    return [];
  }
}
